import { Action } from '@ngrx/store';

import { SearchMask } from '../../../xena/core/shared/models/searchmask.model';
import { DocumentWithId, DocumentWithRev } from '../../services/db/models/document-with-type';


export const SELECT_SEARCH_MASK = '[XENA] SELECT_SEARCH_MASK';

export const SAVE_SEARCH_MASK = '[XENA] SAVE_SEARCH_MASK';
export const SAVE_SEARCH_MASK_SUCCESS = '[XENA] SAVE_SEARCH_MASK_SUCCESS';
export const SAVE_SEARCH_MASK_ERROR = '[XENA] SAVE_SEARCH_MASK_ERROR';

export const LOAD_SEARCH_MASK = '[XENA] LOAD_SEARCH_MASK';
export const LOAD_SEARCH_MASK_SUCCESS = '[XENA] LOAD_SEARCH_MASK_SUCCESS';
export const LOAD_SEARCH_MASK_ERROR = '[XENA] LOAD_SEARCH_MASK_ERROR';

export const UPDATE_SEARCH_MASK = '[XENA] UPDATE_SEARCH_MASK';
export const UPDATE_SEARCH_MASK_SUCCESS = '[XENA] UPDATE_SEARCH_MASK_SUCCESS';
export const UPDATE_SEARCH_MASK_ERROR = '[XENA] UPDATE_SEARCH_MASK_ERROR';

export const DELETE_SEARCH_MASK = '[XENA] DELETE_SEARCH_MASK';
export const DELETE_SEARCH_MASK_SUCCESS = '[XENA] DELETE_SEARCH_MASK_SUCCESS';
export const DELETE_SEARCH_MASK_ERROR = '[XENA] DELETE_SEARCH_MASK_ERROR';


export class SelectSearchMask implements Action {
	readonly type = SELECT_SEARCH_MASK;

	constructor(public payload: SearchMask) {}
}

export class SaveSearchMask implements Action {
	readonly type = SAVE_SEARCH_MASK;

	constructor(public payload: SearchMask) {}
}

export class SaveSearchMaskSuccess implements Action {
	readonly type = SAVE_SEARCH_MASK_SUCCESS;

	constructor(public payload: SearchMask) {}
}

export class SaveSearchMaskError implements Action {
	readonly type = SAVE_SEARCH_MASK_ERROR;
}

export class LoadSearchMask implements Action {
	readonly type = LOAD_SEARCH_MASK;
}

export class LoadSearchMaskSuccess implements Action {
	readonly type = LOAD_SEARCH_MASK_SUCCESS;

	constructor(public payload: Array<SearchMask>) {}
}

export class LoadSearchMaskError implements Action {
	readonly type = LOAD_SEARCH_MASK_ERROR;
}

export class UpdateSearchMask implements Action {
	readonly type = UPDATE_SEARCH_MASK;

	constructor(public payload: SearchMask) {};
}

export class UpdateSearchMaskSuccess implements Action {
	readonly type = UPDATE_SEARCH_MASK_SUCCESS;

	constructor(public payload: SearchMask) {};
}

export class UpdateSearchMaskError implements Action {
	readonly type = UPDATE_SEARCH_MASK_ERROR;
}

export class DeleteSearchMask implements Action {
	readonly type = DELETE_SEARCH_MASK;

	constructor(public payload: SearchMask) {};
}

export class DeleteSearchMaskSuccess implements Action {
	readonly type = DELETE_SEARCH_MASK_SUCCESS;

	constructor(public payload: (DocumentWithId & DocumentWithRev)) {};
}

export class DeleteSearchMaskError implements Action {
	readonly type = DELETE_SEARCH_MASK_ERROR;
}

export type All
	= SelectSearchMask
	| SaveSearchMask
	| SaveSearchMaskSuccess
	| SaveSearchMaskError
	| LoadSearchMask
	| LoadSearchMaskSuccess
	| LoadSearchMaskError
	| UpdateSearchMask
	| UpdateSearchMaskSuccess
	| UpdateSearchMaskError
	| DeleteSearchMask
	| DeleteSearchMaskSuccess
	| DeleteSearchMaskError;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/actions/searchmask.ts